import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms a phone number into a standard format (123) 456-7890
 * If the input is not a string or not a number, returns the provided fallback or 'N/A'
 * It does replace all non-digit characters and spaces before formatting
 * Example:
 *   {{ '1234567890' | phone }} => (123) 456-7890
 *   {{ 1234567890 | phone }} => (123) 456-7890
 *   {{ '1234567' | phone }} => (123) 4567
 *   {{ '12345678' | phone }} => (123) 456-78
 *   {{ '(123)-456-7890' | phone }} => (123) 456-7890
 *   {{ null | phone:'No Phone' }} => No Phone
 */
@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(value: string, fallback?: string, ...args: unknown[]): unknown {
    if (!value || (typeof value !== 'string' && typeof value !== 'number') ) {
      return fallback ?? 'N/A';
    }
    // ensure it's a string, remove all characters and spaces except digits and plus sign
    let stringValue = value.toString().replace(/\s*[^\d+]/g, '');
    if (stringValue.length === 0) {
      return fallback ?? 'N/A';
    }

    let countryPrefix = '';

    if (stringValue.startsWith('+')) {
      countryPrefix = stringValue.substring(0, 2) + ' ';
      stringValue = stringValue.substring(2);
    }

    if (stringValue.length <= 3) {
      return `${countryPrefix}(${stringValue})`;
    }
    if (stringValue.length <= 7) {
      return `${countryPrefix}(${stringValue.substring(0, 3)}) ${stringValue.substring(3, )}`;
    }

    return `${countryPrefix}(${stringValue.substring(0, 3)}) ${stringValue.substring(3, 6)}-${stringValue.substring(6, )}`;
  }
}
